import * as React from 'react';
import {BodyAlt, BodyMono} from 'sail/Text';
import {InlineLink} from 'sail/InlineLink';
import {FormattedMessage} from 'react-intl';

const CheckerMessage = (props) => {
  const {name} = props;

  switch (name) {
    case 'creates_payment_intent':
      return (
        <BodyAlt>
          <FormattedMessage
            id="docsApp.legacy.components.checkerMessages.createsPaymentIntent"
            description=""
            defaultMessage="Created a PaymentIntent with <BodyMono>amount</BodyMono> and <BodyMono>currency</BodyMono>"
            values={{
              BodyMono: (str) => <BodyMono>{str}</BodyMono>,
            }}
          />
        </BodyAlt>
      );
    case 'creates_card_with_elements':
      return (
        <BodyAlt>
          <FormattedMessage
            id="docsApp.legacy.components.checkerMessages.createsCardWithElements"
            description=""
            defaultMessage="Successfully collected card details with Stripe Elements"
          />
        </BodyAlt>
      );
    case 'creates_payment_method_and_mandate_with_elements':
      return (
        <BodyAlt>
          <FormattedMessage
            id="docsApp.legacy.components.checkerMessages.createsPaymentMethodAndMandateWithElements"
            description=""
            defaultMessage="Successfully collected IBAN and mandate acknowledgement with Stripe Elements"
          />
        </BodyAlt>
      );
    case 'confirms_payment_intent':
      return (
        <BodyAlt>
          <FormattedMessage
            id="docsApp.legacy.components.checkerMessages.confirmsPaymentIntent"
            description=""
            defaultMessage="Submitted the payment to Stripe"
          />
        </BodyAlt>
      );
    case 'authenticated_the_payment':
      return (
        <BodyAlt>
          <FormattedMessage
            id="docsApp.legacy.components.checkerMessages.authenticatedThePayment"
            description=""
            defaultMessage="Authenticated the payment"
          />
        </BodyAlt>
      );
    case 'fails_with_insufficient_funds':
      return (
        <BodyAlt>
          <FormattedMessage
            id="docsApp.legacy.components.checkerMessages.failsWithInsufficientFunds"
            description=""
            defaultMessage="Failed with decline code <BodyMono>insufficient_funds</BodyMono>. Make sure to show this error on your payment form"
            values={{
              BodyMono: (str) => <BodyMono>{str}</BodyMono>,
            }}
          />
        </BodyAlt>
      );
    case 'saved_pm_details_to_customer':
      return (
        <BodyAlt>
          <FormattedMessage
            id="docsApp.legacy.components.checkerMessages.savedPmDetailsToCustomer"
            description=""
            defaultMessage="Saved the payment method details to a Customer"
          />
        </BodyAlt>
      );
    case 'collected_pm_details_and_mandate':
      return (
        <BodyAlt>
          <FormattedMessage
            id="docsApp.legacy.components.checkerMessages.collectedPmDetailsAndMandate"
            description=""
            defaultMessage="Collected payment method details and mandate acknowledgement"
          />
        </BodyAlt>
      );
    case 'handles_payment_intent_success':
      return (
        <BodyAlt>
          <FormattedMessage
            id="docsApp.legacy.components.checkerMessages.handlesPaymentIntentSuccess"
            description=""
            defaultMessage="Successfully received the <BodyMono>payment_intent.succeeded</BodyMono> webhook"
            values={{
              BodyMono: (str) => <BodyMono>{str}</BodyMono>,
            }}
          />
        </BodyAlt>
      );
    case 'handles_payment_intent_failure':
      return (
        <BodyAlt>
          <FormattedMessage
            id="docsApp.legacy.components.checkerMessages.handlesPaymentIntentFailure"
            description=""
            defaultMessage="Successfully received the <BodyMono>payment_intent.payment_failed</BodyMono> webhook"
            values={{
              BodyMono: (str) => <BodyMono>{str}</BodyMono>,
            }}
          />
        </BodyAlt>
      );
    case 'dispute_created_webhook':
      return (
        <BodyAlt>
          <FormattedMessage
            id="docsApp.legacy.components.checkerMessages.disputeCreatedWebhook"
            description=""
            defaultMessage="Optional: Successfully received <BodyMono>charge.dispute.created</BodyMono> webhook. <InlineLink>Learn more about disputes.</InlineLink>"
            values={{
              BodyMono: (str) => <BodyMono>{str}</BodyMono>,
              InlineLink: (str) => (
                <InlineLink href="/docs/payments/sepa-debit#disputed-payments">
                  {str}
                </InlineLink>
              ),
            }}
          />
        </BodyAlt>
      );
    case 'creates_payment_intent_saved_to_customer':
      return (
        <BodyAlt>
          <FormattedMessage
            id="docsApp.legacy.components.checkerMessages.createsPaymentIntentSavedToCustomer"
            description=""
            defaultMessage="Created a PaymentIntent with <BodyMono>payment_method_types</BodyMono>, <BodyMono>customer</BodyMono>, and <BodyMono>setup_future_usage</BodyMono>"
            values={{
              BodyMono: (str) => <BodyMono>{str}</BodyMono>,
            }}
          />
        </BodyAlt>
      );
    default:
      return null;
  }
};

export default CheckerMessage;
